import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ShieldOff, Loader2, KeyRound } from 'lucide-react';
import { toast } from 'sonner';

function McpAuthorizations() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [revoking, setRevoking] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/mcp-consent/authorizations/list');
      setItems(r.data.authorizations || []);
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Não foi possível carregar as autorizações.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const revokeAll = async () => {
    if (!window.confirm('Revogar TODAS as autorizações do conector Claude? Ele precisará se conectar de novo.')) return;
    setRevoking(true);
    try {
      const r = await api.post('/mcp-consent/authorizations/revoke-all');
      toast.success(`${r.data.revoked} autorização(ões) revogada(s).`);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Não foi possível revogar.');
    } finally {
      setRevoking(false);
    }
  };

  return (
      <div className="space-y-4" data-testid="mcp-authorizations-page">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <KeyRound className="w-5 h-5 text-emerald-700" />
            <h1 className="text-lg font-semibold text-gray-900">Autorizações ativas</h1>
          </div>
          <Button
            variant="outline"
            onClick={revokeAll}
            disabled={revoking || items.length === 0}
            className="border-red-300 text-red-700 hover:bg-red-50"
            data-testid="mcp-revoke-all-button"
          >
            {revoking ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <ShieldOff className="w-4 h-4 mr-2" />}
            Revogar todas
          </Button>
        </div>

        <Card className="p-4">
          {loading ? (
            <div className="text-gray-500 text-sm flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" /> Carregando...</div>
          ) : items.length === 0 ? (
            <p className="text-gray-500 text-sm" data-testid="mcp-authorizations-empty">Nenhuma autorização ativa. O Claude ainda não se conectou (ou todas foram revogadas).</p>
          ) : (
            <div className="divide-y divide-gray-100" data-testid="mcp-authorizations-list">
              {items.map((it) => (
                <div key={it.token_hash} className="py-3 flex items-center justify-between text-sm">
                  <div>
                    <p className="font-medium text-gray-900">{it.client_name}</p>
                    <p className="text-gray-500 text-xs">Autorizado em {new Date(it.created_at).toLocaleString('pt-BR')}</p>
                  </div>
                  <Badge className="bg-emerald-100 text-emerald-800 border-emerald-200">Ativo até {String(it.expires_at).slice(0, 10)}</Badge>
                </div>
              ))}
            </div>
          )}
        </Card>
      </div>
  );
}

export default McpAuthorizations;
